import React, { useEffect } from 'react';
import useCheckScreenWidth from './useCheckScreenWidth';
import { useLocation, useNavigate } from 'react-router-dom';

const useHandleChangeSizeNavigation = () => {
  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop
  const pathData = useLocation();
  const currentPath = pathData.pathname;
  const navigate = useNavigate();

  const block404 =
    screenWidth < 1024 && currentPath.startsWith('/main/');

  useEffect(() => {
    console.log('currentPath=>', currentPath);
    if (
      screenWidth < 1024 &&
      currentPath.startsWith('/main/')
    ) {
      navigate({
        pathname: '/main',
      });
    }
  }, [currentPath, screenWidth]);

  return block404;
};

export default useHandleChangeSizeNavigation;
